import React from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type KindVisibilityControlProps = {
  visible: boolean
  onClick: () => void
}

const KindVisibilityControl = ({ visible, onClick }: KindVisibilityControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick()
  }

  return (
    <div className={cn('control', 'kind-visibility')} data-graph-type="control" title={visible ? 'Hide edges of this kind' : 'Show edges of this kind'}>
      <a className="icon" onClick={handleClick}>
        {visible ? <FaEye aria-hidden /> : <FaEyeSlash aria-hidden />}
        <span className="sr-only">{visible ? 'Hide edges of this kind' : 'Show edges of this kind'}</span>
      </a>
    </div>
  )
}

export default KindVisibilityControl
